<template>
  <!-- 业务入库单列表-->
  <div class="businessReceiptList">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="handleResetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></SiruiSearch>
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        :showFooter="1 == 1"
        :footerMethod="footerTotalCols ? footerMethodTotal : null"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :formatter="item.formatter"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
        >
          <template v-slot="{ row }">
            <template v-if="item.field == 'inboundStatus'">
              {{ businessReceiptStatus[row[item.field]] }}
            </template>
            <span v-else-if="item.dictType">
              {{ row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ row[item.field] | formatTableColumn(item.format) }}
            </span>
            <template v-else>{{ row[item.field] }}</template>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <creat-dialog ref="creatDialog" :inboundCompanyNo="userInfo.companyCode"></creat-dialog>
    <!-- sunxueping 添加批量导入 -->
    <sirui-upload
      :action="action"
      @getData="getData"
      ref="SiruiUpload"
      :data="{ ...token }"
    ></sirui-upload>
    <!-- 新业务导入 -->
    <sirui-upload
      :action="actionNew"
      @getData="getData"
      ref="SiruiUploadNew"
      :data="{ ...token }"
    ></sirui-upload>
    <!--批量确认 -->
    <BatchConfirmDialog ref="batchConfirmDialog" />
    <!-- ====================== -->
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import API from '@/api/logisticsCenter/businessReceipt.js';
  import AGENCY_API from '@/api/agencyContract/index';
  // import COMPANY_API from '@/api/masterData/company';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import creatDialog from './components/creatDialog';
  import { mapEnumList, mapEnumsComputed } from '@/common/js/enums';
  import { businessReceiptStatus, columns } from './data';
  import DataBaseAPI from '@/api/dataBase';
  // ============ sunxueping 添加批量导入 ============
  import siruiUpload from '@/components/SiruiUpload';
  import { filterEmpty, getUserCompanyList } from '@/common/js/util';
  import tableMixins from '@/common/mixins/table.js';
  import BatchConfirmDialog from '@/components/Dialog/batchConfirmDialog';
  // ================================================

  export default {
    name: 'businessReceiptList',
    mixins: [tableMixins],
    components: {
      SiruiTable,
      SiruiSearch,
      creatDialog,
      //  sunxueping 添加批量导入
      siruiUpload,
      BatchConfirmDialog,
      // =======================
    },
    data() {
      return {
        //底部合计列-字段名，数字类型金额amount，数量quantity等）判断小数点
        footerTotalCols: {
          //业务结算价含税金额 //业务结算价净值//合同价含税金额//合同价净值//合同价税额
          amount: [
            'businessVariablePriceWithTax',
            'businessVariablePricePureAmount',
            'businessContractPriceWithTax',
            'businessContractPricePureAmount',
            'businessVariablePriceTaxAmount',
          ], //合同价税额
          //业务入库数量  //已匹配数量 //可匹配数量
          quantity: ['inboundQuantity', 'matchedQuantity', 'matchAvailableQuantity'],
        },
        load: false,
        query: {
          judgeFlag: null,
          judgeAbFlag: null, //可匹配数量
          voucherCode: null,
          distributionBatchNo: null,
        },
        multipleSelection: [], //存放选中的值
        menuButtonList: [],
        tableData: [],
        companyList: getUserCompanyList(),
        columnList: [],
        columnListDefault: columns,
        //  sunxueping 添加批量导入
        action: API.IMPORT_BUSINESS_RECEIPT,
        actionNew: API.IMPORT_BUSINESS_RECEIPT_NEW,
        importType: '',
        // =======================
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      ...mapEnumsComputed({ businessReceiptStatus }),
      // sunxueping 添加
      token() {
        let obj = {
          access_token: this.userInfo.access_token,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          tenantCode: this.userInfo.tenantCode,
        };
        if (this.importType != 'new') obj['originFlag'] = this.importType;
        return obj;
      },
      // ==============
      //搜索字段
      searchColumns() {
        const query = this.query;
        const departmentUrl = query.inboundCompanyNo ? `${DataBaseAPI.GET_PERSON_API}` : '';
        const statusList = mapEnumList(businessReceiptStatus);
        return [
          {
            prop: 'inboundNo',
            name: this.$t('businessReceiptList.search.businessEntryNumber'),
            type: 'input',
          },
          {
            prop: 'inboundStatus',
            name: this.$t('businessReceiptList.table.inboundStatus'),
            type: 'select',
            options: statusList,
            clearabled: true,
          },
          {
            type: 'searchTableSpec',
            prop: 'storageNo', // 仓库
            name: this.$t('businessReceiptList.search.warehouse'),
            searchType: 'warehouse',
            isMultiple: true,
          },
          {
            prop: 'businessInboundBatchNo',
            name: this.$t('businessReceiptList.search.incomingBatch'),
            type: 'input',
          },
          {
            type: 'startDaterangePicker',
            prop: 'inboundDateStart',
            name: this.$t('businessReceiptList.search.businessWarehouseStart'),
          },
          {
            type: 'endDaterangePicker',
            prop: 'inboundDateEnd',
            name: this.$t('businessReceiptList.search.businessWarehouseEnd'),
          },
          {
            // 采购合同号
            type: 'input',
            prop: 'contractNo',
            name: this.$t('businessReceiptList.search.purchaseContract'),
          },
          {
            type: 'select', // 公司默认为账户登录者所属公司，不可操作
            name: this.$t('businessReceiptList.search.company'),
            prop: 'inboundCompanyNo',
            options: this.companyList,
            filterable: false,
          },
          {
            type: 'ajaxSelect',
            prop: 'inboundDepartmentNo',
            name: this.$t('businessReceiptList.search.department'),
            apiUrl: departmentUrl,
            apiData: {
              id: this.userInfo.userCode,
              userCode: this.userInfo.userCode,
              personName: this.userInfo.userName,
              personCompanyCode: this.query.inboundCompanyNo,
            },
            filterable: true,
            clearable: true,
            method: 'post',
            dataString: 'data.personDepartmentInfo',
            valueKey: 'personDepartmentCode',
            labelKey: 'personDepartmentName',
          },
          {
            prop: 'partnerNo', // 供应商
            name: this.$t('businessReceiptList.search.supplier'),
            type: 'searchTableSpec',
            searchType: 'supplier',
            extraData: {
              departmentCode: this.query.inboundDepartmentNo, //部门
              companyCode: this.query.inboundCompanyNo, //公司
            },
            isMultiple: true,
          },
          {
            prop: 'productNo', // 商品
            name: this.$t('businessReceiptList.search.goods'),
            type: 'searchTableSpec',
            searchType: 'goodsDetail',
            isMultiple: true,
          },
          {
            prop: 'gmtCreateStart',
            name: this.$t('businessReceiptList.search.createDateStart'),
            type: 'startDaterangePicker',
          },
          {
            prop: 'gmtCreateEnd',
            name: this.$t('businessReceiptList.search.createDateEnd'),
            type: 'endDaterangePicker',
          },
          {
            prop: 'inboundCreatePersonNo', // 制单人
            name: this.$t('businessReceiptList.search.makingPeople'),
            type: 'searchTableSpec',
            searchType: 'personnel',
            isMultiple: true,
          },
          {
            type: 'input',
            prop: 'instructionNo',
            name: this.$t('businessReceiptList.search.SupplierDelivery'),
          },
          {
            type: 'ajaxSelect',
            prop: 'tradeType',
            name: this.$t('businessReceiptList.search.tradeType'),
            apiUrl: AGENCY_API.DICT_LIST,
            apiData: { dictType: 'purchase-trade-type' },
          },
          {
            // 入账状态
            type: 'dict',
            prop: 'accountingStatus',
            name: this.$t('paymentList.table.accountingStatus'),
            dictType: 'post_status',
          },
          {
            //外部合同号
            type: 'input',
            prop: 'externalContractNo',
            name: this.$t('businessReceiptList.search.externalContract'),
          },
          {
            //已匹配数量
            type: 'selectInput',
            prop: ['judgeFlag', 'matchedQuantity'],
            name: this.$t('businessReceiptList.search.matchedQuantity'),
            options: [
              { value: 1, label: this.$t('businessReceiptList.search.gt') },
              { value: 2, label: this.$t('businessReceiptList.search.lt') },
              { value: 3, label: this.$t('businessReceiptList.search.notEqual') },
              { value: 4, label: this.$t('businessReceiptList.search.equal') },
            ],
          },
          {
            //可匹配数量
            type: 'selectInput',
            prop: ['judgeAbFlag', 'matchAvailableQuantity'],
            name: this.$t('businessReceiptList.table.matchAvailableQuantity'),
            options: [
              { value: 1, label: this.$t('businessReceiptList.search.gt') },
              { value: 2, label: this.$t('businessReceiptList.search.lt') },
              { value: 3, label: this.$t('businessReceiptList.search.notEqual') },
              { value: 4, label: this.$t('businessReceiptList.search.equal') },
            ],
          },
          {
            prop: 'voucherCode',
            name: '凭证号',
            type: 'input',
            placeholder: this.$t('请输入凭证号'),
          },
          {
            prop: 'distributionBatchNo',
            name: '物流批次号',
            type: 'input',
            placeholder: '请输入物流批次号',
          },
        ];
      },
    },
    mounted() {
      this.initQuery();
      this.$nextTick(() => {
        this.query.inboundCompanyNo = this.userInfo.companyCode;
        this.getButtonList();
        this.getData();
      });
    },
    methods: {
      // sxp update TAPD ID1001859 20210312
      handleResetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.multipleSelection = [];
        this.initQuery();
        this.getData();
      },
      initQuery() {
        const query = {};
        this.searchColumns.forEach((item) => {
          if (item.prop) {
            if (typeof item.prop === 'string') {
              query[item.prop] = undefined;
            } else {
              item.prop.forEach((prop) => {
                query[prop] = undefined;
              });
            }
          }
        });
        // query.inboundCompanyNo = this.userInfo.companyCode;
        // query.inboundDepartmentNo = this.userInfo.departmentCode;
        this.query = Object.assign({}, this.query, query);
      },
      // 获取数据
      getData(search) {
        const query = this.getQuery();
        // 默认有分页、公司参数
        if (search && Object.keys(query).length == 2) {
          this.$message({
            showClose: true,
            message: this.$t('search.nosearchError'),
            type: 'error',
          });
          return;
        }
        this.load = true;
        this.$axios
          .post(API.LIST_BUSINESS_INBOUND, query)
          .then((res) => {
            this.load = false;
            if (0 == res.data.code) {
              this.tableData = res.data.data.list;
              this.$refs.siruiTable.setPageTotal(res.data.data.total);
            }
          })
          .catch(() => {
            this.load = false;
          });
      },
      getQuery() {
        // 分页数据
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const query = this.query;
        const result = Object.assign({}, query, {
          pageNum,
          pageSize,
          storageNo: query.storageNo && query.storageNo[0] ? query.storageNo[0].storageCode : '',
          // partnerNo: query.partnerNo && query.partnerNo[0] ? query.partnerNo[0].partnerCode : '',
          // productNo: query.productNo && query.productNo[0] ? query.partnerNo[0].productDetailCode : '',
          productNo: this.handleData(query.productNo, 'productDetailCode'), //商品描述
          partnerNo: this.handleData(query.partnerNo, 'partnerCode'), //供应商
          inboundCreatePersonNo:
            query.inboundCreatePersonNo && query.inboundCreatePersonNo[0]
              ? query.inboundCreatePersonNo[0].id
              : '',
        });
        return filterEmpty(result);
      },
      //处理数据
      handleData(multipleSelection, key) {
        let selectList = multipleSelection ? multipleSelection : [];
        let list = [];
        selectList.forEach((item) => {
          if (key == 'partnerCode') {
            if (item.allPartnerCode && item['allPartnerCode'] != undefined) {
              list.push(item.allPartnerCode);
            } else {
              list.push(item.partnerCode);
            }
          } else if (key == 'productDetailCode') {
            //合并的数据
            if (item.allProductDetailCode && item['allProductDetailCode'] != undefined) {
              list.push(item.allProductDetailCode);
            } else {
              list.push(item.productDetailCode);
            }
          }
        });
        return list.length != 0 ? list.join(',') : null;
      },
      //点击按钮触发的方法
      chooseClick(type) {
        if (type === 'add') {
          this.$refs.creatDialog.defaultVisible = true;
        }
        // ============ sunxueping 添加批量导入 ============
        else if (type == 'import_openning') {
          this.handleImport();
          this.importType = 'openning';
        } else if (type == 'import_estimate') {
          this.handleImport('estimate');
          this.importType = 'estimate';
        } else if (type == 'import_new') {
          this.handleImport('new');
          this.importType = 'new';
        }
        // ============ sunxueping 添加导出 ============
        else if (type == 'export') {
          this.export();
        }
        // 批量确认
        else if (type == 'doBatchConfirm') {
          this.doBatchConfirm(
            'AE_PO_MTL_ACCEPT',
            { ids: this.multipleSelection.map((it) => it.inboundId) },
            'ids'
          );
        }
        // 批量过账
        else if (type == 'syncVoucher') {
          this.syncVoucher();
        }
        // 批量标记过账
        else if (type == 'signSyncVoucher') {
          this.signSyncVoucher();
        }
        // 批量生成凭证
        // else if(type==='generateCredentials'){
        //   this.batchGenarateVoucher("AE_PO_MTL_ACCEPT", {ids: this.multipleSelection.map(it=>it.inboundId) }, 'ids');
        // }
        else if (type == 'submit') {
          this.submit();
        } else if (type == 'print') {
          this.print();
        }
        // ================================================
      },
      // ============ sunxueping 添加批量导入 ============
      handleImport(type) {
        if (type == 'new') {
          this.$refs.SiruiUploadNew.openDialog(true);
        } else {
          this.$refs.SiruiUpload.openDialog(true);
        }
      },
      // ============ sunxueping 添加批量过账 ============
      submit() {
        const params = {};
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        params.ids = [];
        if (selectedList.length > 0) {
          selectedList.map((item) => {
            params.ids.push(item.id);
          });
        }
        if (this.multipleSelection.length > 0) {
          this.multipleSelection.map((item) => {
            params.ids.push(item.id);
          });
        }
        if (!params.ids.length) {
          this.$alert('请选择请选择单据');
          return false;
        }
        this.loading.startLoading();
        this.$confirmAction(this.$t('confirm.batchSubmit'), this.$t('confirm.removeBatchSubmit'))
          .then(() => {
            this.checkBeforeSubmit(params);
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('salePurchase.message.gitUpSubmit'),
            });
            this.loading.endLoading();
          });
      },
      // 批量提交前校验
      checkBeforeSubmit(params) {
        this.loading.startLoading();
        this.$axios.post(API.SUBMIT_CHECK_BUSINESS_INBOUND, params).then((res) => {
          this.loading.endLoading();
          if (0 == res.data.code) {
            this.batchSubmit(params);
          } else if (res.data.code == 9) {
            // 提交时校验软提示
            this.$confirmAction('提示', res.data.msg)
              .then(() => {
                this.batchSubmit(params);
              })
              .catch(() => {});
          } else if (res.data.code == 10) {
            // 提交时校验软提示
            this.$reportErrors({
              msg: res.data.msg,
              code: res.data.code,
              callback: () => {
                //确认提交，cancelValidate传值true取消校验
                params.cancelValidate = true;
                this.batchSubmit(params);
              },
            });
          } else {
            this.$alert(res.data.msg);
          }
        });
      },

      // 批量提交 调用接口
      batchSubmit(params) {
        this.loading.startLoading();
        this.$axios.post(API.BATCH_COMMIT, params).then((res) => {
          this.loading.endLoading();
          if (0 == res.data.code) {
            this.$message({ showClose: true, message: res.data.msg, type: 'success' });
            this.getData();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },

      // 批量过账
      syncVoucher() {
        const params = {};
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        params.ids = [];
        if (selectedList.length > 0) {
          selectedList.map((item) => {
            params.ids.push(item.id);
          });
        }
        if (this.multipleSelection.length > 0) {
          this.multipleSelection.map((item) => {
            params.ids.push(item.id);
          });
        }
        if (!params.ids.length) {
          this.$alert('请选择请选择单据');
          return false;
        }
        this.batchSyncVoucher(API.PURCHASE_RETURN_VOUCHER, params);
      },

      // 批量标记过账
      signSyncVoucher() {
        const params = {};
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        params.ids = [];
        if (selectedList.length > 0) {
          selectedList.map((item) => {
            params.ids.push(item.id);
          });
        }
        if (this.multipleSelection.length > 0) {
          this.multipleSelection.map((item) => {
            params.ids.push(item.id);
          });
        }
        if (!params.ids.length) {
          this.$alert('请选择请选择单据');
          return false;
        }
        this.batchSyncVoucher(API.PURCHASE_RETURN_SIGN_VOUCHER, params);
      },
      //导出
      export() {
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        const query = this.query;
        const result = Object.assign({}, query, {
          storageNo: query.storageNo && query.storageNo[0] ? query.storageNo[0].storageCode : '',
          productNo: this.handleData(query.productNo, 'productDetailCode'), //商品描述
          partnerNo: this.handleData(query.partnerNo, 'partnerCode'), //供应商
          inboundCreatePersonNo:
            query.inboundCreatePersonNo && query.inboundCreatePersonNo[0]
              ? query.inboundCreatePersonNo[0].id
              : '',
        });
        const params = filterEmpty(result);
        params.ids = [];
        if (selectedList.length > 0) {
          selectedList.map((item) => {
            params.ids.push(item.id);
          });
        }
        if (this.multipleSelection.length > 0) {
          this.multipleSelection.map((item) => {
            params.ids.push(item.id);
          });
        }

        if (!params.ids.length) {
          this.$confirmAction('提示', '未选中导出单据,系统将按查询条件导出,是否继续?')
            .then(async () => {
              // 获取数据
              this.$axios.post(API.EXPORT_BUSINESS_RECEIPT, filterEmpty(params)).then((res) => {
                if (res.data.code === 0) {
                  window.location.href = res.data.data;
                } else {
                  this.$alert(res.data.msg);
                }
              });
            })
            .catch(() => {
              return false;
            });
        } else {
          // 获取数据
          this.$axios.post(API.EXPORT_BUSINESS_RECEIPT, filterEmpty(params)).then((res) => {
            if (res.data.code === 0) {
              window.location.href = res.data.data;
            } else {
              this.$alert(res.data.msg);
            }
          });
        }
      },
      handlePath(row) {
        const { inboundNo, contractNo } = row;
        let pathRoute = {
          path: '/logistics/businessReceiptEdit',
          name: 'businessReceiptEdit',
          meta: {
            keepAlive: true,
            title: '业务入库单编辑',
          },
          query: inboundNo && contractNo ? { inboundNo, contractNo, sourceType: '2' } : {},
        };
        this.$store.dispatch('tagsView/addTabView', pathRoute).then(() => {
          this.$nextTick(() => {
            this.$router.push(pathRoute);
          });
        });
      },
      //双击事件
      dblclickEvent(value) {
        const row = value.row;
        this.handlePath(row);
      },
      // 打印
      print() {
        const params = {};
        const selectedList = this.multipleSelection.concat(
          this.$refs.siruiTable.getCheckboxReserveRecords()
        );
        let hnList = selectedList.filter(
          (item) => item.inboundCompanyNo == this.$globalVar.subserver.companyCode
        );
        console.log(hnList);
        if (hnList.length > 0 && selectedList.length !== hnList.length) {
          this.$message({
            showClose: true,
            message: '海宁与其他公司的模板不同，不可以一起批量打印',
            type: 'error',
            duration: 8000,
          });
          return;
        }
        params.printFlag = hnList[0] ? 'PRINT_BUSINESSINBOUND_HN' : 'PRINT_BUSINESSINBOUND';
        params.getFileUrl = API.GET_FILE;
        params.idList = [];
        selectedList.map((item) => {
          params.idList.push(item.businessInboundNo);
        });
        if (!params.idList.length) {
          this.$alert('请选择请选择单据');
          return false;
        }
        this.printEntityCode(params);
      },
    },
  };
</script>
